import { ContextStore, ExperimentStore, PageStore } from 'bernie-plugin-mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { evaluateAndLogExperiment } from 'stores/utils';

import { FilterModel, FilterOptionModel } from './filter-types';

import { getFilterTypesWithOption, updateFilterTypeValue } from './field-utils';

import { CheckboxGroup } from './checkbox-group';
import { FormFieldBinding } from './form-field-binding';
import { SearchFormFieldProps } from 'components/common/search-form';

export interface PopularFilterProps extends SearchFormFieldProps {
  context?: ContextStore;
  experiment?: ExperimentStore;
  page?: PageStore;
}

export const PopularFilterComponent: React.FunctionComponent<PopularFilterProps> = observer(props => {
  const isChecked = (option: FilterOptionModel) => Boolean(props.model?.[option.filterType]?.includes(option.value));

  return <CheckboxGroup getFilterType={getFilterType} isChecked={isChecked} handleChange={handlePopularFilterChange(props)} {...props} />;
});

const getFilterType = (option: FilterOptionModel) => option.filterType;

export const handlePopularFilterChange = (props: PopularFilterProps) => (event: React.BaseSyntheticEvent) => {
  const target = event.target;
  const { value, filterType } = target;
  const { context, experiment, page } = props;

  const { model, sortAndFilterOptions, updateModel } = props;

  const modelValue = model && model[filterType];

  if (typeof updateModel !== 'function' || (!modelValue && modelValue !== '')) {
    return;
  }

  // Get all filterTypes that have this option
  const filterTypesToUpdate = getFilterTypesWithOption(sortAndFilterOptions, value);

  // Update the option in each filterType
  filterTypesToUpdate.forEach(key => {
    const filterTypeModel: FilterModel = sortAndFilterOptions[key];

    let newArrayValue = updateFilterTypeValue(model[key].slice(), value);

    if (key === 'neighborhood' && !newArrayValue) {
      newArrayValue = filterTypeModel.options ? filterTypeModel.options[0].value : '';
    }

    updateModel({
      target: {
        name: filterTypeModel.title,
        value: newArrayValue,
      },
    });
  });

  if (
    filterType === 'poi' &&
    evaluateAndLogExperiment('Default_Sort_to_Distance_for_Popular_Location_Filter', context, experiment, page) === 1
  ) {
    updateModel({
      target: {
        name: 'sort',
        value: 'DISTANCE',
      },
    });
  }
};

export const PopularFilter = inject('context', 'experiment', 'page')(FormFieldBinding(PopularFilterComponent));
